import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { RootState } from "../../../redux/store";

import { Paths } from "../../../common/constants";
import { ZENDESK_IDS } from "../../../common/constants/enum";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";

import {
  createSupportTicket,
  getCmsLinks,
  getUserDeviceInfo,
} from "../../../common/utils";
// import { getDynamicSupportEmail } from "../services/action";

const useSupportHelper = () => {
  const initialValues = {
    name: "",
    email: "",
    subject: "",
    supportReason: "",
    supportMessage: "",
  };

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { cmsLinks } = useAppSelector(
    (state: RootState) => state.globalcontent,
  );

  const supportReasonOptions = [
    { label: "Databis Platform", value: "databis_platform" },
    { label: "Email Not Registered", value: "email_not_registered" },
    {
      label: "Verification Code Not Received",
      value: "verification_code_not_received",
    },
    { label: "Other", value: "support_reason_other" },
  ];

  /** on submitting the support form */
  const onSubmitHandler = async (
    values: typeof initialValues,
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void },
  ) => {
    setSubmitting(true);

    const { browser, deviceType, deviceManufacturer, osName } =
      getUserDeviceInfo();

    // Build custom_fields array conditionally
    const custom_fields = [
      browser !== undefined && browser !== ""
        ? {
            id: ZENDESK_IDS.BROWSER,
            value: browser,
          }
        : null,
      deviceManufacturer !== undefined && deviceManufacturer !== ""
        ? {
            id: ZENDESK_IDS.DEVICEMANUFACTURER,
            value: deviceManufacturer,
          }
        : null,
      deviceType !== undefined && deviceType !== ""
        ? {
            id: ZENDESK_IDS.DEVICETYPE,
            value: deviceType,
          }
        : null,
      osName !== undefined && osName !== ""
        ? {
            id: ZENDESK_IDS.OPERATING_SYSTEM,
            value: osName,
          }
        : null,
      {
        id: ZENDESK_IDS.LOGGEDIN,
        value: false,
      },
      {
        id: ZENDESK_IDS.SUPPORTREASON,
        value: values.supportReason,
      },
    ].filter(Boolean);

    const zendeskPayload = {
      ticket: {
        ticket_form_id: ZENDESK_IDS.BRANDSPLATFORM, // {{brandsPlatformForm}}
        subject: values.subject,
        description: values.supportMessage,
        comment: {
          body: values.supportMessage,
          public: true,
        },
        requester: {
          email: values.email.trim(),
          name: values.name.trim(),
        },
        custom_fields,
      },
    };
    try {
      dispatch(createSupportTicket(zendeskPayload, () => handleOpen()));
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleModalClose = () => {
    handleClose();
    navigate(Paths.LOGIN);
  };

  const handleSupportBackBtnClick = () => {
    navigate(-1);
  };

  // const handleBackToLoginClick = () => {
  //   navigate(Paths.LOGIN);
  // };

  useEffect(() => {
    dispatch(getCmsLinks());
    //eslint-disable-next-line
  }, []);

  return {
    open,
    cmsLinks,
    initialValues,
    supportReasonOptions,

    dispatch,
    handleClose,
    onSubmitHandler,
    handleModalClose,
    // handleBackToLoginClick,
    handleSupportBackBtnClick,
  };
};

export default useSupportHelper;
